import { render, staticRenderFns } from "./InvoiceItemsTotal.vue?vue&type=template&id=2872f307&scoped=true&"
import script from "./InvoiceItemsTotal.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemsTotal.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceItemsTotal.vue?vue&type=style&index=0&id=2872f307&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872f307",
  null
  
)

export default component.exports